export enum FreeOrPaid {
    free = 'Free',
    paid = 'Paid'
}